import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FaCheckCircle } from 'react-icons/fa';

const points = [
  'Decades of experience in residential & commercial construction',
  'Dedicated to quality workmanship on every project',
  'Bilingual team — ¡Hablamos Español!',
];

const WhyUs = () => {
  return (
    <Section>
      <Inner>
        <ImageCol>
          <MainImage
            src="https://firebasestorage.googleapis.com/v0/b/champion-building.appspot.com/o/plans.jpg?alt=media&token=be398b5c-107a-49cb-a957-0d38a1ca895d"
            alt="Construction planning"
          />
          <AccentBox>
            <AccentNumber>500+</AccentNumber>
            <AccentLabel>Projects Delivered</AccentLabel>
          </AccentBox>
        </ImageCol>

        <TextCol>
          <Eyebrow>Why Choose Us</Eyebrow>
          <Heading>Why Champion &amp; Champion?</Heading>
          <BodyText>
            Champion &amp; Champion is a construction company dedicated to providing high-quality
            services across Los Angeles. With decades of experience, we specialize in residential,
            commercial, and industrial projects — always with integrity and excellence at the core.
          </BodyText>
          <CheckList>
            {points.map((point, i) => (
              <CheckItem key={i}>
                <FaCheckCircle style={{ color: '#c89432', flexShrink: 0, marginTop: '2px' }} />
                <span>{point}</span>
              </CheckItem>
            ))}
          </CheckList>
          <CtaLink to="/contact">Start Your Project Today →</CtaLink>
        </TextCol>
      </Inner>
    </Section>
  );
};

const Section = styled.section`
  background: #fff;
  padding: 96px 32px;
  @media (max-width: 768px) {
    padding: 64px 20px;
  }
`;

const Inner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 72px;
  @media (max-width: 960px) {
    flex-direction: column;
    gap: 48px;
  }
`;

const ImageCol = styled.div`
  flex: 1;
  position: relative;
  flex-shrink: 0;
  max-width: 520px;
  @media (max-width: 960px) {
    max-width: 100%;
    width: 100%;
  }
`;

const MainImage = styled.img`
  width: 100%;
  height: 480px;
  object-fit: cover;
  border-radius: 6px;
  display: block;
  @media (max-width: 768px) {
    height: 300px;
  }
`;

const AccentBox = styled.div`
  position: absolute;
  bottom: -24px;
  right: -24px;
  background: #c89432;
  color: #fff;
  padding: 24px 28px;
  border-radius: 6px;
  text-align: center;
  box-shadow: 0 8px 24px rgba(200, 148, 50, 0.35);
  @media (max-width: 480px) {
    bottom: -16px;
    right: -8px;
    padding: 16px 20px;
  }
`;

const AccentNumber = styled.div`
  font-family: "Poppins", sans-serif;
  font-size: 2rem;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 4px;
`;

const AccentLabel = styled.div`
  font-family: "Poppins", sans-serif;
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

const TextCol = styled.div`
  flex: 1;
  padding-bottom: 24px;
`;

const Eyebrow = styled.p`
  font-family: "Poppins", sans-serif;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #c89432;
  margin-bottom: 12px;
`;

const Heading = styled.h2`
  font-family: "Poppins", sans-serif;
  font-size: clamp(1.6rem, 2.5vw, 2.2rem);
  font-weight: 700;
  color: #111827;
  margin-bottom: 20px;
  line-height: 1.3;
  padding-left: 18px;
  border-left: 4px solid #c89432;
`;

const BodyText = styled.p`
  font-family: "Poppins", sans-serif;
  font-size: 1rem;
  color: #6b7280;
  line-height: 1.8;
  margin-bottom: 28px;
`;

const CheckList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 36px;
`;

const CheckItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-family: "Poppins", sans-serif;
  font-size: 0.95rem;
  color: #374151;
  line-height: 1.55;
`;

const CtaLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 0.95rem;
  color: #c89432;
  padding: 14px 32px;
  border: 2px solid #c89432;
  border-radius: 4px;
  transition: background 0.25s ease, color 0.25s ease, transform 0.2s ease;
  &:hover {
    background: #c89432;
    color: #fff;
    transform: translateY(-2px);
  }
`;

export default WhyUs;
